























import Vue from 'vue'
import Component from 'vue-class-component'
import Card from '@/components/Card.vue'
import Icon from '@/components/Icon.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'

@Component({
  components: {
    LoaderWrapper,
    Card,
    Icon
  },
  props: {
    tabs: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
})
export default class SideBar extends Vue {

}
